/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StringReferenceReadModel } from './StringReferenceReadModel';
import {
    StringReferenceReadModelFromJSON,
    StringReferenceReadModelFromJSONTyped,
    StringReferenceReadModelToJSON,
    StringReferenceReadModelToJSONTyped,
} from './StringReferenceReadModel';

/**
 * 
 * @export
 * @interface StringReferenceReadModelPagedList
 */
export interface StringReferenceReadModelPagedList {
    /**
     * 
     * @type {number}
     * @memberof StringReferenceReadModelPagedList
     */
    readonly totalCount: number;
    /**
     * 
     * @type {Array<StringReferenceReadModel>}
     * @memberof StringReferenceReadModelPagedList
     */
    readonly entities: Array<StringReferenceReadModel>;
}

/**
 * Check if a given object implements the StringReferenceReadModelPagedList interface.
 */
export function instanceOfStringReferenceReadModelPagedList(value: object): value is StringReferenceReadModelPagedList {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('entities' in value) || value['entities'] === undefined) return false;
    return true;
}

export function StringReferenceReadModelPagedListFromJSON(json: any): StringReferenceReadModelPagedList {
    return StringReferenceReadModelPagedListFromJSONTyped(json, false);
}

export function StringReferenceReadModelPagedListFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringReferenceReadModelPagedList {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'entities': ((json['entities'] as Array<any>).map(StringReferenceReadModelFromJSON)),
    };
}

export function StringReferenceReadModelPagedListToJSON(json: any): StringReferenceReadModelPagedList {
    return StringReferenceReadModelPagedListToJSONTyped(json, false);
}

export function StringReferenceReadModelPagedListToJSONTyped(value?: Omit<StringReferenceReadModelPagedList, 'totalCount'|'entities'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

